import React from 'react';
import './Contact.css';
import OpeningTimes from './OpeningTimes';

const ContactForm = () => {
  return (
    <>
      <div className="contact-info">
        <h1 className="text-4xl py-2 font-Poppins font-semibold">
          Kontaktieren <span className="text-primary">Sie uns</span>
        </h1>
        <ul className="flex flex-col space-y-2">
          {/* <li className="flex items-center text-lg space-x-2 hover:scale-105 transition-transform duration-200">
            <i className="fab fa-whatsapp text-primary"></i>
            <a
              href="https://wa.me/43662432330"
              target="_blank"
              rel="noopener noreferrer"
              className="text-black"
            >
              +43 662 432 330
            </a>
          </li> */}
          <li className="flex items-center text-lg space-x-2 hover:scale-105 transition-transform duration-200">
            <i className="fas fa-envelope text-primary"></i>
            <a
              href="mailto:office@digitalezahnpraxis.at"
              className="text-black"
            >
              office@digitalezahnpraxis.at
            </a>
          </li>
          <li className="flex items-center  text-lg space-x-2 hover:scale-105 transition-transform duration-200">
            <i className="fas fa-phone text-primary"></i>
            <a href="tel:+43662432330" className="text-black">
              +43 662 432 330
            </a>
          </li>
          <li className="flex items-center text-lg space-x-2 hover:scale-105 transition-transform duration-200">
            <i className="fas fa-map-marker-alt text-primary"></i>
            <a
              href="https://maps.google.com/maps/dir//Roseggerstra%C3%9Fe+23+5020+Salzburg+Austria/@47.8113054,13.0293659,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x477690749fa8f263:0xe12681e6b4025290"
              target="_blank"
              rel="noopener noreferrer"
              className="text-black"
            >
              Roseggerstraße 23, 5020 Salzburg, Austria
            </a>
          </li>
        </ul>
        <div className="flex flex-col items-start pt-12">
          <OpeningTimes />
        </div>
      </div>
    </>
  );
};

export default ContactForm;
